import React, { useEffect, useState } from 'react'
import Header from '../../layout/Header';
import { getGames, getGamesByMerchant, Token_Generator, updateGameStatus } from '../../../actions/auth';
import swal from "sweetalert";
import { decrypt } from '../../../utils/encodingdecoding';
import GameCardForMerchant from './GameCardForMerchant';

const GamesForMerchant = () => {
    const [games, setGames] = useState([]);
    const [merGames, setMerGames] = useState([])
    const [loader, setLoader] = useState(false);
    const [selectedGames, setSelectedGames] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [flag, setFlag] = useState(false)

    const fetch = async () => {
        setLoader(true);

        const token = JSON.parse(localStorage.getItem("token_gen"));
        const superToken = await Token_Generator();

        const res = await getGamesByMerchant(token.access_token);

        let activeMerGames = [];
        if (res.message === "Success") {
            activeMerGames = res.data?.filter((g) => g.customerPortal) || [];

            const tempSelectedGameRes = activeMerGames.map((g) => ({
                gameId: g.gameId,
                customerPortal: g.customerPortal,
                isEdit: false,
                points: g.points
            }));

            setMerGames(res?.data);
            setSelectedGames(tempSelectedGameRes);
            setFlag(tempSelectedGameRes.length > 0);
        }

        const pointsMap = res?.data?.reduce((acc, g) => {
            acc[g?.gameId] = g?.points;
            return acc;
        }, {});

        const gameRes = await getGames(superToken.access_token);
        if (gameRes.message === "Data Retrieved Successfully") {
            const tempGame = Array.isArray(gameRes?.data)
                ? gameRes.data
                    .filter((ele) => ele.status === "Y")
                    .map((game) => ({
                        ...game,
                        points: pointsMap?.[game?.gameId] ?? 0
                    }))
                : [];

            setGames(tempGame);
        }

        setLoader(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    const handleSelect = (gameId, action, item) => {
        if (action === "Select") {
            setSelectedGames((prev) => [...prev, { gameId, customerPortal: true, points: item?.points }]);
        } else {
            setSelectedGames((prev) => prev.filter((g) => g.gameId !== gameId));
        }
    };
    const filteredGames = games.filter((game) =>
        game?.gameName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleStatusUpdate = async () => {
        setLoader(true)
        const tempData = selectedGames.map(({ isEdit, ...rest }) => rest);
        const unSelectedGames = merGames
            .filter((item) => !tempData.some((sel) => sel.gameId === item.gameId))
            .map((item) => ({
                gameId: item.gameId,
                customerPortal: false,
                points: item.points
            }));

        const body = {
            merchantCode: decrypt(localStorage.getItem("Id")),
            type: "merchant",
            games: [...tempData, ...unSelectedGames]
        }
        const token = JSON.parse(localStorage.getItem("token_gen"))
        const res = await updateGameStatus(token.access_token, body)
        if (res.message === "Success") {
            await fetch()
            swal({
                position: "center",
                icon: "success",
                title: "Games update successfully",
                showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res.message,
                showConfirmButton: false,
                timer: 5000,
            });
        }

        setLoader(false)
    }
    return (
        <>
            <Header name={"Gamification"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Game Controls</h4>
                                <>Manage game availability and reward values.</>
                            </div>
                            <div className="dashboard__right">
                                <input
                                    className="search"
                                    type="text"
                                    placeholder='Search'
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="giftcard_mainbox">
                            <div className="gc_contentbox  no_margin_left full_width">
                                <div className="gc_content_pbox">
                                    {filteredGames?.length ? (
                                        <>
                                            <div className="campaignSelection__boxes">
                                                <div className="gc_inmainbox">
                                                    {filteredGames.map((item, i) => {
                                                        const isDisabled = !merGames.some((g) => g.gameId === item.gameId); // not in merchant list

                                                        return (
                                                            <div key={i} className="game_innbox">
                                                                <GameCardForMerchant
                                                                    item={item}
                                                                    handleSelect={handleSelect}
                                                                    isSelected={selectedGames}
                                                                    isDisabled={isDisabled}
                                                                    setSelectedGames={setSelectedGames}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div
                                                className="row"
                                                style={{ paddingBottom: "20px" }}
                                            >
                                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div
                                                        className="button-section"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                        }}
                                                    >
                                                        <button
                                                            type="submit"
                                                            onClick={handleStatusUpdate}
                                                            className="btn btn-primary btn-lg"
                                                            disabled={selectedGames?.length > 0 ? false : flag ? false : true}
                                                        >
                                                            Update
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <span className="not_found">No game found</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}


export default GamesForMerchant